module.exports = __webpack_public_path__ + "static/media/login.d91572da.png";